/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_LogisticsInputs */

const vi_nav_logistics = /** @type {(inputs: Nav_LogisticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giao vận`)
};

/**

* @param {Nav_LogisticsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const nav_logistics = /** @type {((inputs?: Nav_LogisticsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_LogisticsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_nav_logistics(inputs)
});